<template>
    <div class="row">
        <div class="col">
            <h2>Not Found</h2>
        </div>
    </div>
</template>
